import { PrimaryButton } from "@/components/Buttons/PrimaryButton";

export const StepsSection = () => {
  return (
    <>
      <div className="w-full bg-primary mx-auto flex items-center">
        <img src="/assets/top-thumba-logo.svg" alt="Main Content Background" className="absolute" />
        <div className="text-center flex-1">
          <div className="border-t border-white w-[120px] mx-auto mt-4" />
          <p className="text-sm font-semibold">HOW TO PLAY</p>
          <div className="border-t border-white w-[120px] mx-auto" />
          <h2 className="text-2xl font-bold mb-4">サンバの遊び方</h2>
        </div>
      </div>
      <div className="bg-light-blue text-white w-full mx-auto">
        <div className="items-center py-8">
          <img
            src="/assets/top-step-01.png"
            alt="Main Content Background"
            className="mb-4 w-[90%] max-w-[370px] mx-auto"
          />
          <img
            src="/assets/top-step-02.png"
            alt="Main Content Background"
            className="mb-4 w-[90%] max-w-[370px] mx-auto"
          />
          <img
            src="/assets/top-step-03.png"
            alt="Main Content Background"
            className="mb-4 w-[90%] max-w-[370px] mx-auto"
          />
          <img src="/assets/top-step-04.png" alt="Main Content Background" className="w-[90%] max-w-[370px] mx-auto" />
        </div>
        <div className="w-full flex justify-center pb-8 px-4">
          <PrimaryButton
            text="もっと詳しく見る"
            onClick={() =>
              window.open("https://half-pressure-b6c.notion.site/1a6941dfbe4080f18d01ddf1958e51ee", "_blank")
            }
            disabled={false}
            className="font-bold w-full max-w-[370px] sm:max-w-[500px] xl:max-w-[600px]"
          />
        </div>
      </div>
    </>
  );
};
